/* eslint-disable react/jsx-boolean-value */
import React, { useEffect, useState, useRef, useContext } from 'react';
import { observer } from 'mobx-react-lite';
import {
  HrFlexContainer,
  HrCustomButton,
  HrTitleContainer,
  HrTitleH4,
  HrParagraph,
  HrTitleH5,
  HrTitleH6,
  HrGridContainer,
  HrSecondary,
  HrWhite,
  HrButtonHover,
  HrButtonActive,
  HrGrey,
  HrRed,
  HrGreen,
  HrIcon,
  HrButtons,
  Spinner
} from '@components/styles/hr-styles';
import DropboxChooser from 'react-dropbox-chooser';
import useDrivePicker from 'react-google-drive-picker';
import { InputFile } from '@components/form/input';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ErrorMessage } from '@hookform/error-message';
import { serialize } from 'object-to-formdata';
import { get } from 'lodash';
import { LogoDrive, LogoDropbox } from '../../../utils/image-svg';
import useStore from '../../store/useStore';
import Toast from '../../../pipeline/components/Toast';
import { DisplaySettingsContext } from '../../store/display-settings';

const GridContainer = styled(HrGridContainer)`
  grid-template-columns: repeat(3, minmax(150px, 250px));
  gap: 16px;

  @media (max-width: 550px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const FlexContainer = styled(HrFlexContainer)`
  flex-direction: column;
  align-items: flex-start;
  padding: 0 32px;

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

async function loadImageBlob(url, token) {
  const options = {
    method: 'GET'
  };
  if (token) {
    const bearer = `Bearer ${token}`;
    options.headers = {
      Authorization: bearer
      // 'Content-Description': 'File Transfer'
    };
    options.muteHttpExceptions = true;
  }

  if (!url) {
    return null;
  }
  // eslint-disable-next-line no-undef
  const response = await fetch(url, options);
  if (response.status !== 200) {
    return null;
  }
  const imageBlob = await response.blob();
  return imageBlob;
}

const editAction = 'edit';
const limitFiles = 3;
const abortController = {};
export const FilesMultiples = observer(
  ({ clearErrors, formState, control, getValues, setValue, register, setError, postulant, action, trigger }) => {
    const { errors } = formState;
    const [openPicker, data, authResponse] = useDrivePicker();
    const [fileSelected, setFileSelected] = useState({ name: '' });
    const inputRef = useRef();
    const [t] = useTranslation();
    const { driveKey, clientAppDrive } = useStore();
    const [files, setFiles] = useState([]);
    const [toastState, setToastState] = useState({
      visible: false,
      message: null,
      typeToast: null
    });
    const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);
    const refMultipleFile = useRef();
    useEffect(() => {
      if (action === editAction) {
        register('multipleFiles', { required: false });
      } else {
        register('multipleFiles', { required: 'Campo requerido' });
      }
    }, []);
    const err = get(errors, 'multipleFiles');
    useEffect(() => {
      if (err) {
        refMultipleFile.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
        refMultipleFile.current?.focus();
      }
    }, [err]);
    useEffect(() => {
      if (errors.cv_file_multiple && files.length !== 0) {
        const _files = [...files];
        const upp = _files.map((file) => {
          if (file.currentError) {
            file.message = errors.cv_file_multiple?.message;
            file.currentError = false;
          }
          return file;
        });
        clearErrors('cv_file_multiple');
        setFiles(upp);
      }
    }, [files, errors]);

    // drive google
    useEffect(async () => {
      if (data) {
        const { access_token } = authResponse;
        const { 0: file } = data.docs;
        const image = await loadImageBlob(
          `https://www.googleapis.com/drive/v3/files/${file?.id}?alt=media&source=downloadUrl`,
          access_token
        );

        if (image) {
          const file1 = new File([image], file?.name || 'n/a', { type: image.type });
          setFileSelected({
            name: file.name,
            file: file1,
            source: 'drive'
          });
        } else {
          setError('multipleFiles', { message: 'Ocurrio un error al cargar el archivo' });
        }
      }
    }, [data]);

    useEffect(async () => {
      if (files.length >= limitFiles) {
        setToastState({ visible: true, type: 'warning', message: t(`postulant.error.limitFiles`) });
      } else if (files.find((file) => file.name === fileSelected.name)) {
        setToastState({ visible: true, type: 'warning', message: t(`postulant.error.loadedFile`) });
      } else if (fileSelected.name) {
        const _isvalid = await trigger('cv_file_multiple');

        const filesUp = [
          ...files,
          {
            name: fileSelected.name,
            status: _isvalid ? 'added' : 'invalid',
            file: fileSelected.file,
            source: fileSelected.source,
            currentError: _isvalid !== true
          }
        ];
        setFiles(filesUp);
      }
      return () => {
        setValue('cv_file_multiple', null);
      };
    }, [fileSelected]);

    useEffect(() => {
      const _files = [...files];
      const fileSave = _files?.find((file) => file.status === 'added');
      if (fileSave) {
        const { file, name, source } = fileSave;
        const index = _files.indexOf(fileSave);
        _files[index].status = 'loading';
        setFiles(_files);

        saveRequestFile(file, name, source);
      }
    }, [files]);
    const handleDeleteFile = (name) => {
      const _files = [...files];
      const filesUp = _files.filter((_file) => _file.name !== name);
      const formFiles = [...(getValues('multipleFiles') || [])];
      const nameFile = name.replace(/ /g, '_');
      const formFilesUp = formFiles.filter((file) => {
        return file.originalFileName !== nameFile && file.originalFileName !== undefined;
      });
      clearErrors(`loadingfiles__${name}`);
      clearErrors(`cv_file_multiple`);
      setValue('cv_file_multiple', null);
      setValue('multipleFiles', formFilesUp);
      setFiles(filesUp);
      if (abortController[name]) {
        abortController[name].abort();
      }
    };
    const handleRetrySaveFile = (dataR, index) => {
      const { file, name, source } = dataR;
      const _files = [...files];
      _files[index].status = 'loading';
      setFiles(_files);
      saveRequestFile(file, name);
    };

    const handleOpenPicker = (e) => {
      openPicker({
        clientId: `${clientAppDrive}.apps.googleusercontent.com`,
        developerKey: driveKey,
        viewId: 'DOCS',
        showUploadView: true,
        showUploadFolders: false,
        supportDrives: true,
        multiselect: false,
        viewMimeTypes: [
          'application/pdf',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.google-apps.document'
        ],
        locale: 'es'
      });
    };

    const saveRequestFile = (file, name, source) => {
      setError(`loadingfiles__${name}`, 'error');
      // eslint-disable-next-line no-undef
      abortController[name] = new AbortController();

      const promise = window
        .fetch('/app/vacancies/saveAttachedFile', {
          method: 'POST',
          body: serialize({ cv_file: file }),
          // mode: 'cors',
          signal: abortController[name].signal
        })
        .then((res) => res.json())
        .then((res) => {
          const { response, result } = res;
          const { originalFileName, temporalFileName } = response;
          const findFile = files.find((_file) => _file.name === name);
          if (findFile && findFile.status === 'loading') {
            setFiles((prev) => {
              const _prev = [...prev] || [];
              const index = _prev.findIndex((_file) => _file.name === name);
              _prev[index].status = result;
              return _prev;
            });
            const multipleFiles = getValues('multipleFiles') || [];
            setValue(
              'multipleFiles',
              [
                ...multipleFiles,
                {
                  originalFileName,
                  temporalFileName,
                  source: source || 'local'
                }
              ],
              { shouldValidate: true }
            );
            setValue('cv_file_multiple', null);
            clearErrors(`loadingfiles__${name}`);
          }
        })
        .catch((err) => {
          console.error(`Download error: ${err.message}`);
        });
    };
    const renderFilesSelected = () => {
      return files.map((file, index) => {
        return (
          <HrFlexContainer key={file.name}>
            <HrParagraph color={darkMode ? 'white' : ''}>{file.name}</HrParagraph>
            {file.status === 'loading' && <Spinner category={darkMode ? 'primary' : ''} className='hr-Charge' />}

            {file.status === 'success' && <HrIcon className='hr-Qualified' color={HrGreen} />}
            {file.status === 'invalid' && (
              <>
                <HrParagraph color={HrRed}>
                  <HrIcon className='hr-No-qualified' color={HrRed} /> <span>{file.message || ''}</span>
                </HrParagraph>{' '}
              </>
            )}
            {file.status === 'error' && (
              <>
                <HrParagraph color={HrRed}>
                  <HrIcon className='hr-No-qualified' color={HrRed} />{' '}
                  <span>{t('postulant.error.invalidFileGeneral')}</span>
                </HrParagraph>{' '}
                <HrButtons
                  type='button'
                  size='medium'
                  category='tertiaryGray'
                  onClick={() => {
                    handleRetrySaveFile(file, index);
                  }}
                >
                  <HrIcon className='hr-Change' color='Hr-black' />
                </HrButtons>
              </>
            )}
            <HrButtons
              type='button'
              size='medium'
              category='tertiaryGray'
              onClick={() => {
                handleDeleteFile(file.name);
              }}
            >
              Eliminar
            </HrButtons>
          </HrFlexContainer>
        );
      });
    };

    return (
      <HrFlexContainer flexDirection='column' alignItems='flex-start'>
        <>
          <HrTitleContainer ref={refMultipleFile} flexWrap='wrap'>
            <HrTitleH4 color={darkMode ? 'white' : ''} fontSizeSetting={fontSizeSetting} isRequired={action !== editAction}>{t(`postulant.curriculum.title`)}</HrTitleH4>
            <HrTitleH6 color={darkMode ? '#DADADA' : HrGrey} fontSizeSetting={fontSizeSetting}>{t('postulant.curriculum.descriptionMultiple')}</HrTitleH6>
          </HrTitleContainer>
          <FlexContainer>
            <HrTitleH5 color={darkMode ? 'white' : ''} fontSizeSetting={fontSizeSetting}>{t('postulant.curriculum.file_selected')}</HrTitleH5>
            <GridContainer>
              <HrCustomButton
                type='button'
                padding='6px'
                borderWidth='1px'
                fontSize='14px'
                minHeight='40px'
                height='40px'
                maxHeight='40px'
                color={darkMode ? 'white' : HrSecondary}
                backgroundColor={darkMode ? 'transparent' : HrWhite}
                borderColor={errors.cv_file ? HrRed : darkMode ? 'white' : HrSecondary}
                backgroundColorHover={ darkMode ? '#26293A' : HrButtonHover}
                backgroundColorActive={ darkMode ? '#26293A' : HrButtonActive}
                borderColorHover={ darkMode ? 'white' : ''}
                borderColorActive={ darkMode ? 'white' : '' }
                className='dropbox-button'
                onClick={() => {
                  inputRef.current.click();
                }}
              >
                <span className='hr-Home' />
                {t('postulant.curriculum.button.myFiles')}
              </HrCustomButton>
              <DropboxChooser
                appKey='8438j5ehmiwemr2'
                success={async (files) => {
                  const { 0: file } = files;
                  const image = await loadImageBlob(file?.link);
                  if (image) {
                    const file1 = new File([image], file?.name || 'n/a');
                    setFileSelected({
                      name: file.name,
                      file: file1,
                      source: 'dropbox'
                    });
                  }
                  // this.onSuccess(files);
                }}
                linkType='direct'
                cancel={(ddd) => {
                  // console.log(ddd);
                }}
                extensions={['.pdf', '.doc', '.docx']}
              >
                <HrCustomButton
                  type='button'
                  padding='6px'
                  borderWidth='1px'
                  fontSize='14px'
                  minHeight='40px'
                  height='40px'
                  maxHeight='40px'
                  color={darkMode ? 'white' : HrSecondary}
                  backgroundColor={darkMode ? 'transparent' : HrWhite}
                  borderColor={errors.cv_file ? HrRed : darkMode ? 'white' : HrSecondary}
                  backgroundColorHover={ darkMode ? '#26293A' : HrButtonHover}
                  backgroundColorActive={ darkMode ? '#26293A' : HrButtonActive}
                  borderColorActive={ darkMode ? 'white' : '' }
                  borderColorHover={ darkMode ? 'white' : ''}
                  className='dropbox-button'
                  width='100%'
                >
                  <LogoDropbox width={20} height={23} />
                  {t('postulant.curriculum.button.dropbox')}
                </HrCustomButton>
              </DropboxChooser>

              <HrCustomButton
                type='button'
                padding='6px'
                borderWidth='1px'
                fontSize='14px'
                minHeight='40px'
                height='40px'
                maxHeight='40px'
                color={darkMode ? 'white' : HrSecondary}
                backgroundColor={darkMode ? 'transparent' : HrWhite}
                borderColor={errors.cv_file ? HrRed : darkMode ? 'white' : HrSecondary}
                backgroundColorHover={ darkMode ? '#26293A' : HrButtonHover}
                backgroundColorActive={ darkMode ? '#26293A' : HrButtonActive}
                borderColorHover={ darkMode ? 'white' : ''}
                borderColorActive={ darkMode ? 'white' : '' }
                className='dropbox-button'
                onClick={(e) => handleOpenPicker(e)}
              >
                <LogoDrive width={20} height={23} />
                {t('postulant.curriculum.button.driver')}
              </HrCustomButton>
            </GridContainer>
            <HrFlexContainer>
              <HrParagraph fontSizeSetting={fontSizeSetting} color={darkMode ? '#DADADA' : HrGrey}>{t('postulant.curriculum.description')}</HrParagraph>
            </HrFlexContainer>
            <InputFile
              inputRef={inputRef}
              inputFile={fileSelected}
              formState={formState}
              control={control}
              setError={setError}
              setInputFile={setFileSelected}
              clearErrors={clearErrors}
              register={register}
              setValue={setValue}
              name='cv_file_multiple'
              validate={{
                required: false,
                size: true, // { max: 5000000 },
                format: true
              }}
              isMultiple
              trigger={trigger}
            />
            {renderFilesSelected()}
            {toastState.visible && (
              <Toast
                text={toastState.message}
                isVisible={toastState.visible}
                type={toastState.type}
                onClose={() => setToastState({ ...toastState, visible: false })}
                msDelay={6000}
              />
            )}
            {errors?.multipleFiles?.type === 'required' && (
              <>
                <ErrorMessage
                  errors={errors}
                  name='multipleFiles'
                  render={({ message }) => <HrParagraph color={HrRed}>{message}</HrParagraph>}
                />
              </>
            )}
          </FlexContainer>
        </>
      </HrFlexContainer>
    );
  }
);
